import Event from ".";

export const eventRoute = (data) => [
  {
    path: "/:lang/admin/events",
    title: "events",
    layout: "admin",
    routeType: "admin",
    component: Event,
  },
];
